import React, { createContext, useContext, useEffect, useState } from 'react';
import { v4 as uuidV4 } from 'uuid';
const initialState = {
    portalId: 'toast-portal',
    toasts: [],
    loaded: false,
    newToast: {}
};
const defaultUpdate = () => initialState;
const ToastContext = createContext({
    state: initialState,
    setState: defaultUpdate
});
const ToastProvider = ({ children }) => {
    const [state, setState] = useState(initialState);
    return (React.createElement(ToastContext.Provider, { value: { state, setState } }, children));
};
const positionHandler = (position, portalId) => {
    const el = document.getElementById(portalId);
    if (!el)
        return;
    const { right = 24, bottom = 24 } = position;
    el.style.right = right + 'px';
    el.style.bottom = bottom + 'px';
};
const generateContainer = ({ portalId, state, setState }) => {
    if (document.getElementById(portalId))
        return;
    const div = document.createElement('div');
    div.id = portalId;
    div.setAttribute('style', 'position: fixed; bottom: 24px; right: 24px; z-index: 1002');
    document.getElementsByTagName('body')[0].prepend(div);
    setState({ ...state, loaded: true });
};
const useToastContext = () => {
    const { state, setState } = useContext(ToastContext);
    const { portalId } = state;
    useEffect(() => {
        generateContainer({ portalId, state, setState });
        // eslint-disable-next-line
    }, []);
    const addToast = (data) => {
        const newToast = { ...data };
        if (!Object.prototype.hasOwnProperty.call(newToast, 'id')) {
            newToast.id = uuidV4();
        }
        setState((draft) => {
            const array = draft.toasts?.slice() || [];
            if (data?.id && array.find((a) => a.id == data?.id))
                return draft;
            if (array.length == 3) {
                array.shift();
            }
            let draftToast = [...array];
            const lastToast = array[array.length - 1];
            if (lastToast?.disabledAutoClose && lastToast?.type == 'progress') {
                // lastToast is progress type & disabled to autoclose
                array.splice(array.length - 1, 1);
                draftToast = [...array, { ...newToast }, lastToast];
            }
            else {
                draftToast = [...array, { ...newToast }];
            }
            return { ...draft, toasts: draftToast, newToast };
        });
    };
    const editToast = (id, editData) => {
        if (!id)
            return;
        const reservedEditData = editData || [];
        setState((draft) => {
            const toastsClone = draft.toasts?.slice() || [];
            const currentIndex = toastsClone.findIndex((arr) => arr.id == id);
            if (currentIndex < 0) {
                return {
                    ...draft,
                    toasts: [...toastsClone, { ...reservedEditData, id }]
                };
            }
            toastsClone[currentIndex] = {
                ...toastsClone[currentIndex],
                ...reservedEditData
            };
            return { ...draft, toasts: [...toastsClone] };
        });
    };
    const removeToast = (id) => {
        setState((draft) => ({
            ...draft,
            toasts: draft?.toasts?.filter((toast) => toast.id != id)
        }));
    };
    const changeContainerPosition = (position) => {
        if (!portalId)
            return;
        positionHandler(position, portalId);
    };
    return {
        ...state,
        addToast,
        removeToast,
        changeContainerPosition,
        editToast
    };
};
export { useToastContext, ToastProvider };
